import React from 'react'
import { getFormValues, reset } from 'redux-form'
import { toast } from 'react-toastify'
import ListosParaBruto from '../../../models/pesado/listos_para_bruto'
import LeerPesoBruto from '../../../models/pesado/leer_peso_bruto'
import PesoBruto from '../../../models/pesado/peso_bruto'
import PesoDestare from '../../../models/pesado/peso_destare'
import Cea from '../../../models/pesado/cea'
import CeaRechazo from '../../../models/pesado/cea_rechazo'
import PesoMaximoBalanzaBruto from '../../../models/parametro/peso_maximo_balanza_bruto'
import CargaEntranteAutomotorManual from '../../../models/pesado/carga_entrante_automotor_manual'
import { Autocomplete } from '../../../models/autocomplete/autocomplete'
// import Net2relay from '../../../models/barreras/net2relay'
import { FORM_PEDIDO_EGRESO_CALADO, FORM_PESO_BRUTO, FORM_PESO_CON_REMITO, FORM_PESO_DESTARE, FORM_PESO_MANUAL } from '../../../config/forms'
import ParametroText from '../../../models/parametro/parametro_text'
import ParametroInteger from '../../../models/parametro/parametro_integer'
import { INTERVALO_EXTRA_LARGO, INTERVALO_CORTO } from '../../../config/settings'
import LeerPesoDestare from '../../../models/pesado/leer_peso_destare'
import { setShowFooter } from '../../Utils/actions'
import ControlBarreras from '../../../models/pesado/control_barreras'
import Printer from '../../../models/impresora'
import { getCallesVolcadora, obtenerVolcadorasConCerealAsignado, updateHabilitacionCalleDeVolcadora } from '../../Volcadora/actions'
import { getCamionesEntrePlayaCalado, getCamionesListosParaBruto, requestDatosConsultaCpa, getCortesPedidos, getCamionesEntreBrutoYDestare } from '../../Camiones/actions'
import { getCallesDeCaladoPorCerealHumedad, consultaEstadoOcupacionCallesCalado, consultaCalificacionPorCalleCalado } from '../../Calado/actions'
import { TablaCamionesCaladosService } from '../../Camiones/containers/listados/camionesCalados/servicio/tabla_camiones_calados'
import CalleDeBruto from '../../../models/pesado/calle_de_bruto'
import PedidoEgresoCalado from '../../../models/camiones/pedido_egreso_calado'
import { actualizarDatosParaMuiTable } from './TablaPedidoCamionesEnCaladoActions'

const calleDeBruto = new CalleDeBruto()
const pedidoDeBruto = new PedidoEgresoCalado()

export function hideSavePesadoBrutoModal () {
  return (dispatch) => {
    dispatch({ type: 'HIDE_SAVE_PESADO_BRUTO_MODAL' })
  }
}

export function showNoAdmitible () {
  return dispatch => {
    dispatch({ type: 'SHOW_BRUTO_NO_ADMITIBLE' })
  }
}

export function hideNoAdmitible () {
  return dispatch => {
    dispatch({ type: 'HIDE_BRUTO_NO_ADMITIBLE' })
  }
}

export function setShowFooterPesado (show) {
  return (dispatch) => {
    dispatch(setShowFooter(show))
  }
}

export function requestDatosConsultaCea (numero, callback) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CONSULTA_CEA' })
    Cea.getById(numero)
      .then(cea => {
        dispatch({ type: 'RECEIVE_CONSULTA_CEA', cea })
        callback && callback(cea)
      })
  }
}

export function requestDatosConsultaCeaDestare (numero, callback) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_CONSULTA_CEA_DESTARE' })
    Cea.getById(numero)
      .then(cea => {
        dispatch({ type: 'RECEIVE_CONSULTA_CEA_DESTARE', cea })
        callback && callback(cea)
      })
  }
}

export function updateCpeEnBruto (numero, pesoBruto) {
  return (dispatch) => {
    LeerPesoBruto.updatePesoCpeEnBruto(numero, pesoBruto)
      .then(() => {
        dispatch({ type: 'UPDATE_CPE_EN_BRUTO' })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function confirmacionChoferCpeEnBruto (numero, confirmacion) {
  return (dispatch) => {
    const descripcion = confirmacion ? null : 'Rechazo de chofer'
    LeerPesoBruto.updateConfirmacionChoferCpeEnBruto(numero, confirmacion, descripcion)
      .then(() => {
        dispatch({ type: 'UPDATE_CPE_EN_BRUTO' })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function actualizarCalleDeVolcadora (numero, calleDeVolcadora) {
  return (dispatch) => {
    // return PesoBruto.updateCalleDeVolcadora(numero, calleDeVolcadora)
    //   .then(() => {

    dispatch(addCalleDeVolcadora(numero, calleDeVolcadora))
    dispatch({ type: 'UPDATE_CALLE_VOLCADORA_CEA_CON_BRUTO' })
    toast.info(`Se actualizó la calle de volcadora: ${calleDeVolcadora}`)
    // dispatch(actualizarDatos())
    // })
    // .catch((e) => {
    //   console.log(e)
    // })
  }
}

export function addCalleDeVolcadora (numero, calleDeVolcadora) {
  return (dispatch) => {
    LeerPesoBruto.updateCalleVolcadoraCpeEnBruto(numero, calleDeVolcadora)
      .then(() => {
        dispatch({ type: 'UPDATE_CPE_EN_BRUTO' })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function addRechazoEnCpeBruto (numero, descripcion) {
  return (dispatch) => {
    const error = true
    LeerPesoBruto.updateRechazoEnCpeBruto(numero, error, descripcion)
      .then(() => {
        dispatch({ type: 'UPDATE_CPE_EN_BRUTO' })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function requestCeaListaParaBruto (numero, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_LISTA_PARA_BRUTO' })
    ListosParaBruto.getById(numero)
      .then(consultaCeaLista => {
        dispatch({ type: 'RECEIVE_CONSULTA_LISTA_PARA_BRUTO', consultaCeaLista })
        callback && callback(consultaCeaLista)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CONSULTA_LISTA_PARA_BRUTO',
        consultaCeaLista: null
      }))
  }
}

export function resetDemoraDesdeEgreso () {
  return (dispatch) => {
    dispatch({ type: 'RESET_DEMORA_DESDE_EGRESO' })
  }
}

export function calcularDemora (fechaEgresoCalado) {
  const fechaActual = Date.now()
  return (dispatch) => {
    dispatch({ type: 'CALCULAR_DEMORA_DESDE_EGRESO', fechaActual, fechaEgresoCalado })
  }
}

export function balanzaHabilitadaBruto () {
  return (dispatch, getState) => {
    const state = getState()
    const modo = state.pesado.pesajeBruto
    const barrerasForzadas = state.pesado.forzarBarrerasBruto
    if (modo === 'manual' || barrerasForzadas === 'si') {
      return true
    } else {
      return ControlBarreras.getEstadoBarrerasBruto()
        .then((result) => {
          dispatch({ type: 'ESTADO_BARRERAS_BRUTO' })
          if ((result && result[0] && result[0].resultado)) {
            return true
          } else {
            return false
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}

/**
  * admitible en bruto
  * verifica que cumpla las condiciones para ser aceptada en
  * bruto, se adapta ante un PESO o un REPESO, si esta lista
  * para bruto o si no egreso de la playa de calado
  *
  * @pesadoBruto : valor del peso en el momento en que se lee
  * una carta de porte para verificar si es admitible o no.
  *
  * Para pesado automatico, se consulta el estado de las barreras
  * de bruto. Si devuelven true -> se puede pesar. De lo contrario,
  * indica que hay un problema por el cual no estan cerrando las
  * barreras correctamente.
  *
**/
export function admitibleEnBruto (numero, pesadoBruto = null) {
  return async (dispatch, getState) => {
    const state = getState()
    const repeso = (state.pesado.repesoBruto === 1)
    const modo = state.pesado.pesajeBruto
    const sinEgresoCalado = (state.pesado.brutoSinEgresoCalado === 1)
    const enclavamientoBarreras = state.pesado.enclavamientoBarrerasBruto

    const habilitado = await dispatch(balanzaHabilitadaBruto())

    // situaciones posibles de admisión:
    // - existe en listos para bruto
    // - esta en un repeso-> no va a estar en listos para bruto
    // - si no esta egresado de la playa de calado, tampoco va a estar en listos para bruto
    // - en todos los casos, menos pesado modo 'manual' o barreras forzadas, tiene que estar ok barreras
    let messageError
    dispatch(requestDatosConsultaCpa(numero, (cpa) => {
      if (cpa) {
        if (enclavamientoBarreras === 0 || habilitado) { // la balanza esta habilitada para pesar
          dispatch(requestCeaListaParaBruto(cpa.numero, (ceaLista) => {
            if (((ceaLista && ceaLista.numero && !repeso) || repeso) || sinEgresoCalado) {
              dispatch(requestDatosConsultaCea(cpa.numero, async (cea) => {
                if (modo === 'auto') {
                  pesadoBruto = await dispatch(requestPesoBruto())
                }
                if (cea) {
                  if (!ceaLista && cea.fechaDeRechazoEnPesado) {
                    console.log('La carta de porte fue rechazada en pesado, debe volver a realizar el proceso de calado')
                    messageError = 'La carta de porte fue rechazada en pesado, debe volver a realizar el proceso de calado'
                    dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                    dispatch(getCpeEnBruto())
                  } else {
                    if (cea.rechazoAdministrativoCalado === 'P' || cea.rechazoAdministrativoCalado === 'R') {
                      if (cea.rechazoAdministrativoCalado === 'P') {
                        messageError = 'La carta de porte ingresada no tiene autorización del calado'
                        dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                        dispatch(getCpeEnBruto())
                      } else if (cea.rechazoAdministrativoCalado === 'R') {
                        messageError = 'La carta de porte ingresada fue rechazada administrativamente en el calado'
                        dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                        dispatch(getCpeEnBruto())
                      }
                    } else {
                      if (!cea.fechaDeDestare && !cea.fechaDeVolcado) {
                        if (cea.fechaCalado && !repeso) {
                          messageError = 'La carta de porte ingresada ya fue pesada en bruto'
                          dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                          dispatch(getCpeEnBruto())
                        } else {
                          // Pesado correcto
                          dispatch(altaCpeEnBruto(cpa, pesadoBruto))
                          dispatch(getCpeEnBruto())
                        }
                      } else {
                        if (cea.fechaDeDestare) {
                          messageError = 'La carta de porte ingresada ya fue descargada'
                          dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                          dispatch(getCpeEnBruto())
                        } else if (cea.fechaDeVolcado) {
                          messageError = 'La carta de porte ingresada ya fue volcada'
                          dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                          dispatch(getCpeEnBruto())
                        }
                      }
                    }
                  }
                } else {
                  messageError = 'La carta de porte ingresada no tiene proceso de calado'
                  dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
                  dispatch(getCpeEnBruto())
                }
              }))
            } else {
              console.log('fecha de bruto ', cpa.fechaDeBruto)
              if (!cpa.fechaDeEgresoCalado) {
                messageError = 'La carga no fue egresada de la playa de calado'
              } else if (cpa.fechaDeRechazoEnPesado) {
                messageError = 'El número ingresado fue pesado y rechazado en bruto'
              } else if (cpa.fechaDeBruto) {
                messageError = 'El número ingresado ya fue pesado en bruto'
              } else {
                messageError = 'El número ingresado no es admitible en bruto'
              }
              dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
              dispatch(getCpeEnBruto())
            }
          }))
        } else {
          // toast.error('Verifique el estado de las barreras.')
          messageError = 'Verifique el estado de las barreras'
          dispatch(altaCpeEnBruto(cpa, pesadoBruto, messageError))
          dispatch(reset(FORM_PESO_BRUTO))
        }
      } else {
        const cpe = {
          numero: numero,
          pesoBruto: null,
          chofer: null
        }
        console.log('Número incorrecto ', numero)
        messageError = 'Número incorrecto. Verifique que sea la carta de porte correcta.'
        dispatch(altaCpeEnBruto(cpe, pesadoBruto, messageError))
        dispatch(reset(FORM_PESO_BRUTO))
      }
      return dispatch(getCpeEnBruto())
    }))
    // } else {
    //   //toast.error('Verifique el estado de las barreras.')
    //   dispatch(reset(FORM_PESO_BRUTO))
    // }
  }
}

export function resetRemito () {
  return (dispatch) => {
    dispatch({ type: 'PESO_BRUTO_RESET_REMITO' })
  }
}

export function buscarRemito (numero, callback) {
  return (dispatch, getState) => {
    if (numero > 0) {
      dispatch({ type: 'PESO_BRUTO_REQUEST_REMITO', numero })
      return CargaEntranteAutomotorManual.getById(numero)
        .then((remito) => {
          if (remito) {
            // Precarga del remito
            dispatch({ type: 'PESO_BRUTO_RECEIVE_REMITO', remito })
            callback && callback(remito)
          } else {
            // Carga del remito de manera manual
          }
          dispatch(manualNextStep())
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      dispatch(showNoAdmitible())
    }
  }
}

export function deleteDatosRemito (numero, exportador) {
  return () => {
    const partial = exportador.split('-')
    const cuitExportador = parseInt(partial[1].trim())
    return CargaEntranteAutomotorManual.deleteCargaConRemito(numero, cuitExportador)
      .then((resultado) => {
        if (!resultado.error) {
          toast.info('Datos de remito eliminados correctamente')
        } else {
          toast.error('Error al intentar eliminar los datos del remito.')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar eliminar los datos del remito.')
      })
  }
}

export function buscarRemitoBruto (numero, exportador, planta) {
  return (dispatch) => {
    dispatch(reset(FORM_PESO_CON_REMITO))
    dispatch({ type: 'PESO_BRUTO_REQUEST_REMITO', numero })
    dispatch({ type: 'DATOS_BASE_REMITO', exportador, planta })
    const partial = exportador.split('-')
    const cuitExportador = parseInt(partial[1].trim())
    return CargaEntranteAutomotorManual.getRemito(numero, cuitExportador)
      .then((datosRemito) => {
        if (datosRemito.length > 0) {
          const remito = datosRemito[0]
          console.log('Remito existente: ', remito)
          dispatch({ type: 'PESO_BRUTO_RECEIVE_REMITO', remito })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function cargaManualUpdateEntities (entities, updater) {
  return (dispatch) => {
    return Autocomplete.searchSet(entities.searchSet)
      .then((response) => entities.fields.forEach(field =>
        updater(field, response.shift()[0]))
      )
  }
}

// ESO NO DEBERIA IR MAS
export function manualNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_PESADO_MANUAL_NEXT_STEP' })
  }
}

export function manualPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_PESADO_MANUAL_PREV_STEP' })
  }
}

export function brutoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_PESADO_BRUTO_NEXT_STEP' })
  }
}

export function brutoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_PESADO_BRUTO_PREV_STEP' })
  }
}

export function destareNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_PESADO_DESTARE_NEXT_STEP' })
  }
}

export function destarePrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_PESADO_DESTARE_PREV_STEP' })
  }
}

export function fueraDeCircuitoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_FUERA_DE_CIRCUITO_NEXT_STEP' })
  }
}

export function finalizarProcesoPesadoManual () {
  return dispatch => {
    dispatch({ type: 'END_PESADO_MANUAL' })
  }
}

export function actualizarPrecarga (values) {
  return dispatch => {
    dispatch({
      type: 'ACTUALIZAR_PRECARGA_REMITO',
      values
    })
  }
}

export function updateThemeMode (newValue) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_THEME_MODE_BRUTO',
      newValue
    })
  }
}

export function actualizarUltimoPesadoBruto (numero = null) {
  return dispatch => {
    PesoBruto.getUltimoPesado()
      .then((ultimoPesado) => {
        console.log('ultimo pesado ', ultimoPesado)
        if (numero && numero === ultimoPesado.cartaDePorteAutomotor) {
          const mensaje = `Operación realizada exitosamente.
                          Número: ${ultimoPesado.cartaDePorteAutomotor},
                          peso bruto: ${ultimoPesado.pesoBruto},
                          cereal: ${ultimoPesado.claveCereal}`
          toast.success(mensaje)
        }
        dispatch({
          type: 'ACTUALIZAR_ULTIMO_PESADO',
          ultimoPesado
        })
      })
  }
}

// Pesado en bruto para cargas en circuito
// pesado manual o automatico

export function submitPesadoBruto () {
  return (dispatch, getState) => {
    const state = getState()
    const brutoValues = getFormValues(FORM_PESO_BRUTO)(state)
    brutoValues.balancero = state.auth.username
    brutoValues.balanza = state.pesado.balanzaBruto
    const minimo = state.pesado.pesoMinimo
    brutoValues.claveCereal = state.pesado.consultaCeaBruto.claveCereal
    if (brutoValues.pesoBruto >= minimo) {
      return PesoBruto.altaPesado(brutoValues)
        .then((response) => {
          if (response.error) {
            console.log(response.message)
            deleteCpeEnBruto(brutoValues.numero)
            const regex = /\bBalanza no reinicializada\b/
            const match = response.message.match(regex)

            const regex2 = /\bLa carga ya fue pesada en bruto o rechazada en pesado\b/
            const match2 = response.message.match(regex2)

            if (match) {
              const mensajeError = () => { return (<>Error al intentar guardar el peso <br /> <b>{match[0]}</b> </>) }
              const sugerencia = () => {
                return (
                  <div className='toast-sugerencia-texto'>
                    <p>Para este error le sugerimos las siguientes opciones: </p>
                    <b>
                      <p>- Presionar el botón "Volver a leer" para intentar pesar la carga nuevamente.</p>
                      <p>- Solicitar al supervisor que se desactive el equilibrio. Debe verificar que se haya desactivado antes de pesar.</p>
                      <p>- Solicitar al supervisor que se cambie el modo de pesado a MANUAL.</p>
                    </b>
                  </div>
                )
              }
              toast.error(mensajeError, { autoClose: false })
              toast(sugerencia, { autoClose: false, className: 'toast-sugerencia' })
            } else if (match2) {
              const mensajeError = () => { return (<>Error al intentar guardar el peso <br /> <b>{match2[0]}</b> </>) }
              toast.error(mensajeError, { autoClose: false })
            } else {
              toast.error('Error al intentar guardar el peso', { autoClose: false })
            }
          } else {
            dispatch(actualizarUltimoPesadoBruto(brutoValues.numero))
            dispatch(actualizarDatos())
          }
        })
        .catch(error => {
          console.log(error)
          deleteCpeEnBruto(brutoValues.numero)
          toast.error('Error al procesar consulta', { autoClose: false })
        })
    } else {
      deleteCpeEnBruto(brutoValues.numero)
      toast.error('El peso no es válido', { autoClose: false })
    }
  }
}

export function updateAltaRemito () {
  return (dispatch, getState) => {
    const state = getState()
    const remitoValues = getFormValues(FORM_PESO_CON_REMITO)(state)
    remitoValues.planta = state.pesado.plantaRemito
    console.log('tengo estos ?  o no llega a ca ', remitoValues)
    return CargaEntranteAutomotorManual.updateCargaConRemito(remitoValues)
      .then((result) => {
        console.log('result ----> ', result)
        if (!result.error) {
          toast.info('Los datos del remito se actualizaron correctamente')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar actualizar los datos del remito')
      })
  }
}

export function submitAltaRemito () {
  return (dispatch, getState) => {
    const state = getState()
    const remitoValues = getFormValues(FORM_PESO_CON_REMITO)(state)
    remitoValues.numero = state.pesado.numeroRemito
    remitoValues.planta = state.pesado.plantaRemito
    remitoValues.exportador = state.pesado.exportadorRemito
    const cereal = remitoValues.cereal
    const variedad = remitoValues.cerealVariedad || null

    // remitoValues.cerealVariedad = ((cereal.trim() === 'PELLETSC') ? null : remitoValues.cerealVariedad)

    // se crea el registro con los datos del remito
    return CargaEntranteAutomotorManual.altaCargaConRemito(remitoValues)
      .then((result) => {
        if (!result.error) {
          // if (!state.pesado.precargaDatos) {
          //   dispatch(actualizarPrecarga(pesadoValues))
          // }
          dispatch({ type: 'SAVE_CEREAL_REMITO', cereal })
          if (variedad) {
            dispatch({ type: 'SAVE_VARIEDAD_REMITO', variedad })
          }
          toast.info('Los datos del remito se guardaron correctamente')
          // callback && callback(pesadoValues.numero)
        } else {
          toast.error('Error al intentar guardar los datos del remito')
          console.log(result)
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar guardar los datos del remito')
      })
  }
}

export function submitAltaManual (callback) {
  return (dispatch, getState) => {
    const state = getState()
    const manualValues = getFormValues(FORM_PESO_MANUAL)(state)
    manualValues.balancero = state.auth.username
    manualValues.balanza = state.pesado.balanzaBruto
    manualValues.numero = state.pesado.numeroRemito
    return CargaEntranteAutomotorManual.altaCargaManual(manualValues)
      .then((saveStatus) => {
        dispatch({ type: 'SUBMIT_MANUAL_RESPONSE', saveStatus })
        if (!saveStatus.error) {
          dispatch(manualNextStep())
          if (!state.pesado.precargaDatos) dispatch(actualizarPrecarga(manualValues))
          toast.success('Operación realizada exitosamente.')
          callback && callback(manualValues.numero)
        }
      })
      .catch(error => {
        console.log(error)
      })
      // Confirmar Chofer
      // const cuitchofer = window.prompt('Confirme el CUIT del Chofer:')
      // if (cuitchofer != null && cuitchofer.length >= 11) {
      //  console.log('Guardar el cho cho')
      //  manualValues.chofer = cuitchofer
      //  return CargaEntranteAutomotorManual.altaCargaManual(manualValues)
      //    .then((saveStatus) => {
      //      dispatch({ type: 'SUBMIT_MANUAL_RESPONSE', saveStatus })
      //      if (!saveStatus.error) {
      //        dispatch(manualNextStep())
      //        toast.success('Operación realizada exitosamente.')
      //        callback && callback(manualValues.numero)
      //      }
      //    })
      //    .catch(error => {
      //      console.log(error)
      //    })
      // } else {
      //  toast.error('El Chofer no es valido, debe ingresar un CUIT.')
      // }
  }
}

export function submitPesoBrutoRemito () {
  return (dispatch, getState) => {
    const state = getState()
    const remitoValues = getFormValues(FORM_PESO_CON_REMITO)(state)
    remitoValues.balanzaBruto = state.pesado.balanzaBruto
    remitoValues.balancero = state.auth.username
    const pesoMinimo = state.pesado.pesoMinimo
    const pesoMaximo = state.pesado.pesoMaximo

    if (remitoValues.pesoBruto > pesoMinimo && remitoValues.pesoBruto < pesoMaximo) {
      // if (repeso === 0) {
      return CargaEntranteAutomotorManual.altaPesoBrutoRemito(remitoValues)
        .then((result) => {
          console.log(result)
          if (!result.error) {
            toast.success('El peso de bruto fue guardado correctamente')
          } else {
            toast.error('Error al intentar guardar peso de bruto')
          }
        })
        .catch((error) => {
          console.log(error)
          toast.error('Error al intentar guardar peso de bruto')
        })
      // } else {
    //    console.log('repeso')
    //  }
    } else {
      toast.error('Peso incorrecto')
    }
  }
}

export function submitPesadoManual (callback) {
  return (dispatch, getState) => {
    const state = getState()
    const manualValues = getFormValues(FORM_PESO_MANUAL)(state)
    manualValues.balanza = state.pesado.balanzaBruto
    manualValues.id = state.pesado.consultaRemito.id
    // manualValues.nroComprobanteOrigen = state.pesado.consultaRemito.nroComprobanteOrigen
    const minimo = state.pesado.pesoMinimo
    const maximo = state.pesado.pesoMaximo
    console.log('maximo y minimo ', maximo, minimo)
    console.log('manualValues.pesoBruto ', manualValues.pesoBruto)
    if (manualValues.pesoBruto >= minimo) {
      if (manualValues.pesoBruto > maximo) {
        // subir peso maximo
        PesoMaximoBalanzaBruto.incrementarPesoMaximo()
          .then(() => {
            console.log('Se sube el peso Maximo')
          })
      }
      return CargaEntranteAutomotorManual.altaPesadoManual(manualValues)
        .then((saveStatus) => {
          dispatch({ type: 'SUBMIT_MANUAL_RESPONSE', saveStatus })
          if (!saveStatus.error) {
            dispatch(finalizarProcesoPesadoManual())
            toast.success('Operación realizada exitosamente.')
            // desenclavar
            callback && callback()
          }
          // bajar peso maximo
        }).then(() => {
          if (manualValues.pesoBruto > maximo) {
            PesoMaximoBalanzaBruto.decrementarPesoMaximo()
              .then(() => { console.log('Se baja el peso maximo') })
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      dispatch(finalizarProcesoPesadoManual())
      toast.error('El peso no es válido!!!')
    }
  }
}

export function getFotoBruto (numero) {
  return dispatch => {
    PesoBruto.getFotoCeaEnBruto(numero)
      .then(data => {
        dispatch({ type: 'RECEIVE_FOTO_CEA_EN_BRUTO', data })
      })
  }
}

export function resetFotoBruto () {
  return dispatch => {
    dispatch({ type: 'RESET_FOTO_CEA_EN_BRUTO' })
  }
}

// export function submitFueraDeCircuito (callback) {
//   return (dispatch, getState) => {
//     const state = getState()
//     const brutoValues = getFormValues(FORM_PESO_BRUTO)(state)
//     brutoValues.balancero = state.auth.username
//     brutoValues.balanza = state.pesado.balanzaBruto
//     const minimo = state.pesado.pesoMinimo
//     const maximo = state.pesado.pesoMaximo
//     const consultaCea = state.pesado.consultaCea
//     const consultaEjes = state.pesado.consultaEjes
//     const ejes = (brutoValues.tipocamion === 'seisejes') ? 6 : 0
//     const ejesValores = {
//       camion: consultaCea.camion,
//       acoplado: consultaCea.acoplado,
//       cantidadEjes: ejes,
//       bitren: !ejes
//     }
//     console.log('Ejes valores', ejesValores)
//     if (brutoValues.pesoBruto >= minimo) {
//       if (brutoValues.pesoBruto > maximo) {
//         // subir peso maximo
//         PesoMaximoBalanzaBruto.incrementarPesoMaximo()
//           .then(() => {
//             console.log('Se sube el peso Maximo')
//           })
//         if (!consultaEjes) {
//           CamionAcopladoEjes.altaCamionAcoplado(ejesValores)
//             .then(dispatch({ type: 'END_CAMION_ACOPLADO_EJES' }))
//             .catch(error => {
//               console.log(error)
//             })
//         }
//       }
//       return PesoBruto.altaPesado(brutoValues)
//         .then((saveStatus) => {
//           dispatch({ type: 'SUBMIT_BRUTO_RESPONSE', saveStatus })
//           if (!saveStatus.error) {
//             // dispatch(finalizarProcesoPesadoBruto())
//             toast.success('Operación realizada exitosamente.')
//             Net2relay.desenclavar()
//               .then((estado) => {
//                 console.log('desenclavar:', estado)
//               })
//               .catch((error) => {
//                 console.log(error)
//               })
//             callback && callback()
//           }
//           // bajar peso maximo
//         }).then(() => {
//           if (brutoValues.pesoBruto > maximo) {
//             PesoMaximoBalanzaBruto.decrementarPesoMaximo()
//               .then(() => { console.log('Se baja el peso maximo') })
//           }
//         })
//         .catch(error => {
//           console.log(error)
//         })
//     } else {
//       // dispatch(finalizarProcesoPesadoBruto())
//       toast.error('El peso no es válido!!!')
//     }
//   }
// }

// Repeso Bruto
// En pesado automatico o manual
export function submitRepesoBruto () {
  return (dispatch, getState) => {
    const state = getState()
    const brutoValues = getFormValues(FORM_PESO_BRUTO)(state)
    brutoValues.balancero = state.auth.username
    brutoValues.balanza = state.pesado.balanzaBruto
    brutoValues.claveCereal = state.pesado.consultaCeaBruto.claveCereal
    const minimo = state.pesado.pesoMinimo
    if (brutoValues.pesoBruto >= minimo) {
      return PesoBruto.repesado(brutoValues)
        .then((saveStatus) => {
          dispatch({ type: 'SUBMIT_REPESOBRUTO_RESPONSE', saveStatus })
          if (!saveStatus.error) {
            dispatch(addCalleDeVolcadora(brutoValues.numero, brutoValues.calleVolcadora))
            dispatch(actualizarUltimoPesadoBruto(brutoValues.numero))
          } else {
            console.log(saveStatus.error)
            toast.error('Error al intentar repesar CPE', { autoClose: false })
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      toast.error('Peso incorrecto', { autoClose: false })
    }
  }
}

export function mostrarDiferencia (peso) {
  return (dispatch, getState) => {
    const state = getState()
    const consultaCea = state.pesado.consultaCea
    if (consultaCea && consultaCea > 0) {
      const CalcularDiferencia = (peso, consultaCea) => {
        return (parseInt(peso) - parseInt(consultaCea.pesoBrutoOrigen))
      }
      dispatch({ type: 'MOSTRAR_MENSAJE_PESO_ORIGEN' })
      if (CalcularDiferencia(peso, consultaCea) < 0) {
        toast.info(`Diferencia con Peso de Origen ${CalcularDiferencia(peso, consultaCea)} kgs.`,
          { hideProgressBar: true,
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: INTERVALO_EXTRA_LARGO
          })
      } else {
        toast.error(`Diferencia con Peso de Origen ${CalcularDiferencia(peso, consultaCea)} kgs.`,
          { hideProgressBar: true,
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: INTERVALO_EXTRA_LARGO
          })
      }
    }
  }
}

// esta no se va a usar
export function mostrarMensajeAdvertencia (peso) {
  return (dispatch, getState) => {
    const state = getState()
    const minimoAdv = state.pesado.pesoMinimoAdvertencia
    const maximoAdv = state.pesado.pesoMaximoAdvertencia
    dispatch({ type: 'MOSTRAR_MENSAJE_ADVERTENCIA' })
    if (parseInt(peso) <= minimoAdv) {
      toast.warn(`Atención!!! El peso esta cerca del minimo permitido.`, { autoClose: INTERVALO_CORTO })
    } else if (parseInt(peso) >= maximoAdv) {
      toast.warn(`Atención!!! El peso esta cerca del máximo permitido.`, { autoClose: INTERVALO_CORTO })
    }
  }
}

// funcion usada por pesado manual
export function requestPesoBrutoRemito (urlBruto, equilibrioBruto, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_PESO_BRUTO' })
    LeerPesoBruto.leerPesoBruto()
      .then((peso) => {
        const newPeso = peso.leerPesoBruto
        dispatch({ type: 'ACTUALIZAR_PESO_DE_CABEZAL', pesoDeCabezal: newPeso })
        dispatch(mostrarMensajeAdvertencia(newPeso))
        dispatch(mostrarDiferencia(parseInt(newPeso)))
        callback && callback(parseInt(newPeso))
        toast.success('Lectura correcta.')
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function requestPesoBruto (callback) {
  return (dispatch) =>
    LeerPesoBruto.monitor()
      .then((data) => {
        dispatch({ type: 'RECEIVE_PESO_BRUTO' })
        const newPeso = parseInt(data.monitorPesoBruto)
        callback && callback(newPeso)
        return newPeso
      })
      .catch(error => {
        console.log(error)
      })
}

// // no va
// export function rechazoCancel (history) {
//   return (dispatch, getState) => {
//     const state = getState()
//     dispatch({ type: 'CANCEL_RECHAZO_PESADO' })
//     const url = state.pesado.urlOrigen
//     history.push(url)
//   }
// }

// no va
export function rechazarPesado (peso, history) {
  return (dispatch) => {
    dispatch({ type: 'RECHAZO_ESTABLECER_VALORES',
      pesoRechazo: peso,
      urlOrigen: '/pesado/pesobruto'
    })
    history.push('/pesado/rechazo')
  }
}

// // no va
// export function rechazarRepesado (peso, history) {
//   return (dispatch) => {
//     dispatch({ type: 'RECHAZO_ESTABLECER_VALORES',
//       pesoRechazo: peso,
//       urlOrigen: '/pesado/repesobruto'
//     })
//     history.push('/pesado/rechazo')
//   }
// }

// rechazo bruto
export function rechazarCea (callback) {
  return (dispatch, getState) => {
    const state = getState()
    const brutoValues = getFormValues(FORM_PESO_BRUTO)(state)
    brutoValues.balanza = state.pesado.balanzaBruto
    brutoValues.balancero = state.auth.username
    if (brutoValues.numeroRechazo) {
      brutoValues.numero = brutoValues.numeroRechazo
    }

    if (brutoValues.numero) {
      if (brutoValues.motivoRechazo && brutoValues.pesoBruto) {
        return CeaRechazo.nuevoRechazo(brutoValues)
          .then((saveStatus) => {
            if (!saveStatus.error) {
              toast.info(`Se rechazó CPE ${brutoValues.numero}`)
              // actualiza cpe_en_bruto, para mostrar al chofer el rechazo
              const descripcion = `Rechazo - ${brutoValues.motivoRechazo}`
              dispatch(addRechazoEnCpeBruto(brutoValues.numero, descripcion))
              dispatch(actualizarDatos())
            }
          })
          .catch((e) => {
            console.log(e)
            toast.error('Error al intentar rechazar la carta de porte')
          })
      } else {
        if (!brutoValues.pesoBruto) {
          toast.error('Peso de bruto incorrecto')
        } else if (!brutoValues.motivoRechazo) {
          toast.error('No seleccionó el motivo de rechazo')
        }
      }
    } else {
      toast.error('Número inválido')
    }
  }
}

export function getModoPesajeBruto () {
  return dispatch => {
    return dispatch(getParametroTextByName('PESAJEBR'))
      .then((pesajeBruto) => {
        dispatch({ type: 'RECEIVE_MODO_PESAJE_BRUTO', pesajeBruto })
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export function getRepesoBruto () {
  return dispatch => {
    return dispatch(getParametroIntegerByName('REPESOBR'))
      .then((repesoBruto) => {
        dispatch({ type: 'RECEIVE_REPESO_BRUTO', repesoBruto })
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export function getEquilibrioBruto () {
  return dispatch => {
    return dispatch(getParametroIntegerByName('EQUBRUTO'))
      .then((equilibrioBruto) => {
        dispatch({ type: 'RECEIVE_EQUILIBRIO_BRUTO', equilibrioBruto })
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export function getPedirConfirmacionChofer () {
  return dispatch => {
    return dispatch(getParametroIntegerByName('BRCONFIR'))
      .then((pedirConfirmacion) => {
        dispatch({ type: 'RECEIVE_PEDIR_CONFIRMACION_CHOFER', pedirConfirmacion })
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export function getEnclavamientoBarrerasBruto () {
  return dispatch => {
    return dispatch(getParametroIntegerByName('ENBARRBR'))
      .then((enclavamientoBarreras) => {
        dispatch({ type: 'RECEIVE_ENCLAVAMIENTO_BARRERAS_BRUTO', enclavamientoBarreras })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function getEnclavamientoBarrerasDestare () {
  return dispatch => {
    return dispatch(getParametroIntegerByName('ENBARRDE'))
      .then((enclavamientoBarreras) => {
        dispatch({ type: 'RECEIVE_ENCLAVAMIENTO_BARRERAS_DESTARE', enclavamientoBarreras })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function queryParametrosBruto () {
  return dispatch => {
    Promise.all([
      ParametroText.getByNombre('PESAJEBR'),
      ParametroText.getByNombre('BALBRUTO'),
      ParametroText.getByNombre('URLBRUTO'),
      ParametroText.getByNombre('FORBBRUT'),
      ParametroText.getByNombre('CIBARRBR'),
      ParametroInteger.getByNombre('MAXCEABR'),
      ParametroInteger.getByNombre('MAXBRADV'),
      ParametroInteger.getByNombre('MINCEABR'),
      ParametroInteger.getByNombre('MINBRADV'),
      ParametroInteger.getByNombre('EQUBRUTO'),
      ParametroInteger.getByNombre('REPESOBR'),
      ParametroInteger.getByNombre('BRNOEGRE'),
      ParametroInteger.getByNombre('BRCONFIR'),
      ParametroInteger.getByNombre('LIDEMORA'),
      ParametroInteger.getByNombre('ENBARRBR')
    ])
      .then(([
        pesajeBruto,
        balanzaBruto,
        urlBruto,
        forzarBarrerasBruto,
        modoBarrerasBruto,
        pesoMaximo,
        pesoMaximoAdvertencia,
        pesoMinimo,
        pesoMinimoAdvertencia,
        equilibrioBruto,
        repesoBruto,
        brutoSinEgresoCalado,
        pedirConfirmacion,
        limiteDemora,
        enclavamientoBarrerasBruto
      ]) => {
        dispatch({ type: 'RECEIVE_PARAMETROS_BRUTO',
          pesajeBruto,
          balanzaBruto,
          urlBruto,
          forzarBarrerasBruto,
          modoBarrerasBruto,
          pesoMaximo,
          pesoMaximoAdvertencia,
          pesoMinimo,
          pesoMinimoAdvertencia,
          equilibrioBruto,
          repesoBruto,
          brutoSinEgresoCalado,
          pedirConfirmacion,
          limiteDemora,
          enclavamientoBarrerasBruto
        })
      })
  }
}

export function queryParametrosDestare () {
  return dispatch => {
    dispatch({ type: 'REQUEST_PARAMETROS_DESTARE' })
    Promise.all([
      ParametroText.getByNombre('PESAJEDE'),
      ParametroText.getByNombre('BALDESTA'),
      ParametroText.getByNombre('URLDESTA'),
      ParametroText.getByNombre('IMPDESTA'),
      ParametroText.getByNombre('CIBARRDE'),
      ParametroText.getByNombre('FORBDEST'),
      ParametroInteger.getByNombre('MAXCEATA'),
      ParametroInteger.getByNombre('MAXTAADV'),
      ParametroInteger.getByNombre('MINCEATA'),
      ParametroInteger.getByNombre('MINTAADV'),
      ParametroInteger.getByNombre('EQUDESTA'),
      ParametroInteger.getByNombre('REPESODE'),
      ParametroInteger.getByNombre('ENBARRDE')
    ])
      .then(([
        pesajeDestare,
        balanzaDestare,
        urlDestare,
        printerDestare,
        modoBarrerasDestare,
        forzarBarrerasDestare,
        pesoMaximoDestare,
        pesoMaximoAdvertenciaDestare,
        pesoMinimoDestare,
        pesoMinimoAdvertenciaDestare,
        enclavamientoDestare,
        repesoDestare,
        enclavamientoBarrerasDestare
      ]) => {
        dispatch({ type: 'RECEIVE_PARAMETROS_DESTARE',
          pesajeDestare,
          balanzaDestare,
          urlDestare,
          printerDestare,
          modoBarrerasDestare,
          forzarBarrerasDestare,
          pesoMaximoDestare,
          pesoMaximoAdvertenciaDestare,
          pesoMinimoDestare,
          pesoMinimoAdvertenciaDestare,
          enclavamientoDestare,
          repesoDestare,
          enclavamientoBarrerasDestare
        })
      })
  }
}

export function getParametroTextByName (nombre) {
  return dispatch => {
    return ParametroText.getByNombre(nombre)
  }
}
export function getParametroIntegerByName (nombre) {
  return dispatch => {
    return ParametroInteger.getByNombre(nombre)
  }
}

export function updateParametroInteger (nombre, value) {
  return dispatch => {
    return ParametroInteger.updateByNombre(nombre, value)
  }
}

export function updateParametroText (nombre, value) {
  return dispatch => {
    return ParametroText.updateByNombre(nombre, value)
  }
}

export function getCpeEnDestare () {
  return (dispatch) => {
    return LeerPesoDestare.getCpePesadoDestare()
      .then((data) => dispatch({
        type: 'CPE_PESADO_DESTARE',
        data
      }))
  }
}

export function requestPesoDestare (callback) {
  return (dispatch) =>
    LeerPesoDestare.monitor()
      .then((data) => {
        dispatch({ type: 'RECEIVE_PESO_DESTARE' })
        const newPeso = parseInt(data.monitorPesoDestare)
        callback && callback(newPeso)
        return newPeso
      })
      .catch(error => {
        console.log(error)
      })
}

export function requestPesoDestareSinEquilibrio (callback) {
  return (dispatch) =>
    LeerPesoDestare.sinEquilibrio()
      .then((data) => {
        dispatch({ type: 'RECEIVE_PESO_DESTARE_RESTART' })
        const newPeso = parseInt(data.leerPesoDestare)
        callback && callback(newPeso)
        return newPeso
      })
      .catch(error => {
        console.log(error)
      })
}

export function updateShowReimpresionDestare (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_SHOW_REIMPRESION_DESTARE', newValue })
  }
}

export function updatePesoTara (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_TARA', peso })
  }
}

export function updateUrlDestare (url) {
  return dispatch => {
    dispatch({ type: 'UPDATE_URL_DESTARE', url })
    dispatch(updateParametroText('URLDESTA', url))
  }
}

export function updateUrlBruto (url) {
  return dispatch => {
    dispatch({ type: 'UPDATE_URL_BRUTO', url })
    dispatch(updateParametroText('URLBRUTO', url))
  }
}

export function updatePesoMaximoDestare (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MAXIMO_DESTARE', peso })
    dispatch(updateParametroInteger('MAXCEATA', peso))
  }
}

export function updatePesoMaximoBruto (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MAXIMO_BRUTO', peso })
    dispatch(updateParametroInteger('MAXCEABR', peso))
  }
}

export function updatePesoMaximoAdvertenciaDestare (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MAXIMO_ADVERTENCIA_DESTARE', peso })
    dispatch(updateParametroInteger('MAXTAADV', peso))
  }
}

export function updatePesoMaximoAdvertenciaBruto (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MAXIMO_ADVERTENCIA_BRUTO', peso })
    dispatch(updateParametroInteger('MAXBRADV', peso))
  }
}

export function updatePesoMinimoDestare (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MINIMO_DESTARE', peso })
    dispatch(updateParametroInteger('MINCEATA', peso))
  }
}

export function updatePesoMinimoBruto (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MINIMO_BRUTO', peso })
    dispatch(updateParametroInteger('MINCEABR', peso))
  }
}

export function updatePesoMinimoAdvertenciaDestare (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MINIMO_ADVERTENCIA_DESTARE', peso })
    dispatch(updateParametroInteger('MINTAADV', peso))
  }
}

export function updatePesoMinimoAdvertenciaBruto (peso) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PESO_MINIMO_ADVERTENCIA_BRUTO', peso })
    dispatch(updateParametroInteger('MINBRADV', peso))
  }
}

export function setBalanzaDeBruto (balanza, confirmacion) {
  return dispatch => {
    dispatch({ type: 'SET_BALANZA_BRUTO', balanza })
    return dispatch(updateParametroText('BALBRUTO', balanza))
      .then((result) => {
        dispatch(updatePedidoDeConfirmacionBruto(confirmacion))
        return PesoBruto.setBalanzaBruto(balanza)
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function balanzaHabilitadaDestare () {
  return (dispatch, getState) => {
    const state = getState()
    const modo = state.pesado.pesajeDestare
    const barrerasForzadas = state.pesado.forzarBarrerasDestare
    dispatch({ type: 'RESET_ESTADO_BARRERA_DESTARE' })
    if (modo === 'manual' || barrerasForzadas === 'si') {
      if (modo === 'manual') {
        console.log('No se consulta estado de barrera en pesado manual.')
      } else if (barrerasForzadas === 'si') {
        console.log('No se consulta estado de barrera cuando estan forzadas.')
      }
      return true
    } else {
      dispatch({ type: 'ESTADO_BARRERA_ENTRADA_DESTARE' })
      return ControlBarreras.getEstadoBarreraEntradaDestare()
        .then((result) => {
          // console.log('result ', result.resultado)
          if (result && result.resultado) {
            dispatch({ type: 'ESTADO_BARRERA_SALIDA_DESTARE' })
            return ControlBarreras.getEstadoBarreraSalidaDestare()
              .then((result) => {
                if (result && result.resultado) {
                  return true
                } else {
                  const mensaje = 'Verificar barrera optica de salida.'
                  dispatch({ type: 'RECEIVE_ESTADO_BARRERAS_DESTARE', mensaje })
                  toast.error(mensaje)
                  return false
                }
              })
              .catch((e) => {
                console.log(e)
                const mensaje = 'Error al consultar estado de barrera de salida.'
                dispatch({ type: 'RECEIVE_ESTADO_BARRERAS_DESTARE', mensaje })
                toast.error(mensaje)
                return false
              })
          } else {
            const mensaje = 'Verificar posición baja de barreras.'
            dispatch({ type: 'RECEIVE_ESTADO_BARRERAS_DESTARE', mensaje })
            toast.error(mensaje)
            return false
          }
        })
        .catch((e) => {
          console.log(e)
          const mensaje = 'Error al consultar estado de barrera de entrada.'
          dispatch({ type: 'RECEIVE_ESTADO_BARRERAS_DESTARE', mensaje })
          toast.error(mensaje)
          return false
        })
    }
  }
}

export function submitPesadoDestare (repeso, change = null) {
  return async (dispatch, getState) => {
    const state = getState()
    const balanzaHabilitada = await dispatch(balanzaHabilitadaDestare())
    const destareValues = getFormValues(FORM_PESO_DESTARE)(state)
    const enclavamientoBarreras = state.pesado.enclavamientoBarrerasDestare
    const pesoMinimo = 300
    console.log(destareValues)
    if (destareValues.numero && !isNaN(destareValues.numero)) {
      if (enclavamientoBarreras === 0 || balanzaHabilitada) {
        dispatch(requestDatosConsultaCea(destareValues.numero, (cea) => {
          if (cea) {
            destareValues.fechaCalado = cea.fechaDeCalado
            destareValues.balanza = state.pesado.balanzaDestare
            destareValues.chofer = cea.chofer
            destareValues.pesoTaraOrigen = cea.pesoTaraOrigen
            destareValues.modoPesado = state.pesado.pesajeDestare
            if (cea.fechaDeVolcado) {
              if (!cea.fechaDeDestare && !cea.pesoTara) {
                if (destareValues.pesoDestare !== 0) {
                  destareValues.error = false
                  if (destareValues.modoPesado === 'auto') {
                    if (destareValues.pesoDestare > pesoMinimo) {
                      toast.info('Procesando datos')
                      return PesoDestare.altaPesado(destareValues)
                        .then((saveStatus) => {
                          dispatch(getCpeEnDestare())
                          if (!saveStatus.error) {
                            toast.success('Operación realizada exitosamente!')
                          } else {
                            console.log('Error', saveStatus.error)
                            toast.error('Error al procesar.')
                            destareValues.error = true
                            destareValues.errorDescripcion = 'Error al procesar'
                            dispatch(altaCpeEnDestare(destareValues))
                            dispatch(getCpeEnDestare())
                          }
                        })
                    } else {
                      toast.error('Peso no válido')
                      dispatch(reset(FORM_PESO_DESTARE))
                    }
                  } else {
                    toast.info('Procesando datos')
                    console.log('pesa manual')
                    return PesoDestare.altaPesadoManual(destareValues)
                      .then((saveStatus) => {
                        dispatch(getCpeEnDestare())
                        if (!saveStatus.error) {
                          toast.success('Operación realizada exitosamente!')
                        } else {
                          console.log('Error', saveStatus.error)
                          toast.error('Error al procesar.')
                          destareValues.error = true
                          destareValues.errorDescripcion = 'Error al procesar'
                          dispatch(altaCpeEnDestare(destareValues))
                          dispatch(getCpeEnDestare())
                        }
                      })
                  }
                }
              // Si el repesado se realiza desde la interfaz interna voy a conocer el estado de "repeso",
              // en cambio si se selecciona repeso en la cabina, y la lectura se realiza desde la interfaz
              // del chofer, no puedo conocer el estado repeso, pero se que el enclavamiento ("equilibrio")
              // va a estar en false cuando quiera realizar un repesado.
              } else {
                if (repeso) {
                  if (destareValues.modoPesado === 'auto') {
                    toast.info('Procesando datos')
                    return PesoDestare.repeso(destareValues)
                      .then((saveStatus) => {
                        dispatch(getCpeEnDestare())
                        if (!saveStatus.error) {
                          destareValues.error = false
                          dispatch(getCpeEnDestare())
                          toast.success('Operación realizada exitosamente!')
                        } else {
                          console.log('Error', saveStatus.error)
                          toast.error('Error al procesar.')
                          destareValues.error = true
                          destareValues.errorDescripcion = 'Error al procesar'
                          dispatch(getCpeEnDestare())
                        }
                        dispatch(requestPesoDestareSinEquilibrio())
                        dispatch(updateEnclavamiento(1))
                        dispatch(updateParametroInteger('REPESODE', 0))
                        const peso = requestPesoDestare()
                        if (change) { change('pesoDestare', peso && peso) }
                      })
                  } else {
                    toast.info('Procesando datos')
                    return PesoDestare.repesoManual(destareValues)
                      .then((saveStatus) => {
                        if (!saveStatus.error) {
                          destareValues.error = false
                          dispatch(altaCpeEnDestare(destareValues))
                          dispatch(getCpeEnDestare())
                          toast.success('Operación realizada exitosamente!')
                        } else {
                          console.log('Error', saveStatus.error)
                          toast.error('Error al procesar.')
                          destareValues.error = true
                          destareValues.errorDescripcion = 'Error al procesar'
                          dispatch(altaCpeEnDestare(destareValues))
                          dispatch(getCpeEnDestare())
                        }
                        dispatch(updateEnclavamiento(1))
                        dispatch(updateParametroInteger('REPESODE', 0))
                      })
                  }
                } else {
                  destareValues.error = true
                  destareValues.errorDescripcion = 'La carta de porte ya fue descargada'
                  toast.error('La carta de porte ya fue descargada')
                  dispatch(altaCpeEnDestare(destareValues))
                  dispatch(getCpeEnDestare())
                  dispatch(reset(FORM_PESO_DESTARE))
                }
              }
            } else {
              if (cea.fechaDeBruto) {
                destareValues.error = true
                destareValues.errorDescripcion = 'Carta de porte sin volcado'
                toast.error('Carta de porte sin volcado')
                dispatch(altaCpeEnDestare(destareValues))
                dispatch(getCpeEnDestare())
                dispatch(reset(FORM_PESO_DESTARE))
              } else {
                destareValues.error = true
                destareValues.errorDescripcion = 'Carta de porte sin peso bruto'
                toast.error('Carta de porte sin peso bruto')
                dispatch(altaCpeEnDestare(destareValues))
                dispatch(getCpeEnDestare())
                dispatch(reset(FORM_PESO_DESTARE))
              }
            }
          } else {
            dispatch(reset(FORM_PESO_DESTARE))
            destareValues.error = true
            destareValues.errorDescripcion = 'Número de CTG incorrecto, por favor verifique que se esté leyendo la carta de porte que corresponde'
            dispatch(altaCpeEnDestare(destareValues))
          }
        }))
      } else {
        destareValues.error = true
        destareValues.errorDescripcion = 'Verificar posición baja de barreras.'
        destareValues.errorDescripcion = state.pesado.estadoBarrerasDestare
        dispatch(altaCpeEnDestare(destareValues))
        dispatch(reset(FORM_PESO_DESTARE))
        // dispatch({ type: 'RESET_ESTADO_BARRERA_DESTARE' })
      }
    } else {
      console.log('Número incorrecto')

      dispatch(reset(FORM_PESO_DESTARE))
    }
    dispatch({ type: 'RESET_ESTADO_BARRERA_DESTARE' })
  }
}

export function altaCpeEnDestare (cpe) {
  return dispatch => {
    return LeerPesoDestare.altaCpeEnDestare(cpe)
  }
}

export function altaCpeEnBruto (cpe, pesadoBruto, messageError = null) {
  return dispatch => {
    return LeerPesoBruto.altaCpeEnBruto(cpe, pesadoBruto, messageError)
  }
}

export function getUltimoPesadoDestare (callback) {
  return dispatch => {
    PesoDestare.getUltimoPesadoDestare()
      .then((ultimoPesado) =>
        callback && callback(ultimoPesado)
      )
  }
}

export function imprimirTicketDescarga (numero) {
  return dispatch => {
    return Printer.imprimirTicketDescarga(numero)
  }
}

export function reimprimirUltimoTicketDescarga () {
  return dispatch => {
    toast.info('Preparando datos para reimpresión')
    dispatch(getUltimoPesadoDestare((ultimoPesado) => {
      if (ultimoPesado.cartaDePorteAutomotor) {
        toast.info(`Reimprimiendo ticket de descarga de CTG número: ${ultimoPesado.cartaDePorteAutomotor}`)
        dispatch(reimprimirTicketDescarga(ultimoPesado.cartaDePorteAutomotor))
      } else {
        toast.error('No se pudieron obtener correctamente los datos')
      }
    }))
  }
}

export function reimprimirTicketDescarga (numero) {
  return dispatch => {
    return Printer.reimprimirTicketDescarga(numero)
  }
}

export function reimpresionCerealAdherido (numero) {
  return dispatch => {
    return Printer.reimprimirTicketDescargaCerealAdherido(numero)
  }
}

export function verificarYReimprimirTicketDescarga (numero, impresora) {
  return dispatch => {
    Cea.getCeaTicketDescarga(numero)
      .then((result) => {
        console.log(result)
        if (result && result.cartaDePorteAutomotor) {
          toast.success('Impresión correcta!!!')
          return Printer.imprimirTicketDescargaEnImpresora(numero, impresora, 'REIMPRESIÓN')
        } else {
          toast.error('La CPE no tiene descarga!!!')
        }
      })
      .catch()
  }
}

export function updateEnclavamiento (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_ENCLAVAMIENTO_DESTARE', newValue })
    dispatch(updateParametroInteger('EQUDESTA', newValue))
  }
}

export function updateEnclavamientoBruto (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_ENCLAVAMIENTO_BRUTO', newValue })
    dispatch(updateParametroInteger('EQUBRUTO', newValue))
  }
}

export function updatePedidoDeConfirmacionBruto (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_PEDIDO_CONFIRMACION', newValue })
    dispatch(updateParametroInteger('BRCONFIR', newValue))
    const info = newValue === 1
      ? 'Se habilitó el pedido de confirmación del chofer.'
      : 'No se pedirá confirmación del chofer para pesar.'
    toast.info(info)
    toast.info('El balancero debera actualizar la interfaz para aplicar el cambio.', { autoClose: false })
  }
}

export function updatePesoSinEgresoDeCalado (newValue) {
  return dispatch => {
    dispatch({ type: 'PESADO_SIN_EGRESO_DE_CALADO', newValue })
    dispatch(updateParametroInteger('BRNOEGRE', newValue))
    const info = newValue === 1
      ? 'Se habilitó para pesar sin egreso de calado'
      : 'Las cargas sin egreso de calado no podrán ser pesadas en bruto'
    toast.info(info)
    toast.info('El balancero debera actualizar la interfaz para aplicar el cambio.', { autoClose: false })
  }
}

export function escribirPesoDestare (peso) {
  return dispatch => {
    if (!isNaN(peso)) {
      return PesoDestare.escribirPesoDestare(peso)
    }
  }
}

export function updateCicloBarreras (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_CICLO_BARRERAS_DESTARE', newValue })
    dispatch(updateParametroText('CIBARRDE', newValue))
  }
}

export function updateCicloBarrerasBruto (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_CICLO_BARRERAS_BRUTO', newValue })
    dispatch(updateParametroText('CIBARRBR', newValue))
  }
}

export function updateModoPesajeDestare (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_MODO_PESADO_DESTARE', newValue })
    dispatch(updateParametroText('PESAJEDE', newValue))
    toast.info(`Se cambio al modo de pesaje ${newValue}`)
  }
}

export function updateModoPesajeBruto (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_MODO_PESADO_BRUTO', newValue })
    dispatch(updateParametroText('PESAJEBR', newValue))
    toast.info(`Se cambio al modo de pesaje ${newValue}`)
  }
}

export function updateForzarBarreras (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_FORZAR_BARRERAS_DESTARE', newValue })
    dispatch(updateParametroText('FORBDEST', newValue))
  }
}

export function forzarBarreraDestare () {
  return dispatch => {
    dispatch({ type: 'FORZAR_BARRERA_DESTARE' })
    ControlBarreras.forzarBarreraDestare()
    toast.info(`Forzando barreras`)
  }
}

export function anularForzarBarreraDestare () {
  return dispatch => {
    dispatch({ type: 'ANULAR_FORZAR_BARRERA_DESTARE' })
    ControlBarreras.anularForzarBarreraDestare()
    toast.info(`Anulando forzado de barreras`)
  }
}

export function activarBarreraAutomaticoDestare () {
  return dispatch => {
    dispatch({ type: 'ACTIVAR_BARRERA_AUTOMATICO_DESTARE' })
    ControlBarreras.activarBarreraAutomaticaDestare()
    toast.info(`Se cambio el ciclo de las barreras al modo automático`)
  }
}

export function desactivarBarreraAutomaticoDestare () {
  return dispatch => {
    dispatch({ type: 'DESACTIVAR_BARRERA_AUTOMATICO_DESTARE' })
    ControlBarreras.desactivarBarreraAutomaticaDestare()
    toast.info(`Se cambio el ciclo de las barreras al modo manual`)
  }
}

export function activarBarreraAutomaticoBruto () {
  return dispatch => {
    Promise.all([
      ControlBarreras.activarBarreraAutomaticoBruto(),
      dispatch(updateCicloBarrerasBruto('auto'))
    ])
      .then((e) => {
        dispatch({ type: 'ACTIVAR_BARRERA_AUTOMATICO_DESTARE' })
        toast.info(`Se cambio el ciclo de las barreras al modo automático`)
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function desactivarBarreraAutomaticoBruto () {
  return dispatch => {
    Promise.all([
      ControlBarreras.desactivarBarreraAutomaticoBruto(),
      dispatch(updateCicloBarrerasBruto('manual'))
    ])
      .then(() => {
        dispatch({ type: 'DESACTIVAR_BARRERA_AUTOMATICO_BRUTO' })
        toast.info(`Se cambio el ciclo de las barreras al modo manual.`)
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function abrirBarreraEntradaDestare () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_ENTRADA_DESTARE' })
    ControlBarreras.abrirBarreraEntradaDestare()
    toast.info(`Abriendo barrera de entrada`)
  }
}

export function abrirBarreraSalidaDestare () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_SALIDA_DESTARE' })
    ControlBarreras.abrirBarreraSalidaDestare()
    toast.info(`Abriendo barrera de salida`)
  }
}

export function cerrarBarreraEntradaDestare () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_ENTRADA_DESTARE' })
    ControlBarreras.cerrarBarreraEntradaDestare()
    toast.info(`Cerrando barrera de entrada`)
  }
}

export function cerrarBarreraSalidaDestare () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_SALIDA_DESTARE' })
    ControlBarreras.cerrarBarreraSalidaDestare()
    toast.info(`Cerrando barrera de salida`)
  }
}

export function abrirBarreraEntradaBruto () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_ENTRADA_BRUTO' })
    ControlBarreras.abrirBarreraEntradaBruto()
    toast.info(`Abriendo barrera de entrada`)
  }
}

export function cerrarBarreraEntradaBruto () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_ENTRADA_BRUTO' })
    ControlBarreras.cerrarBarreraEntradaBruto()
    toast.info(`Cerrando barrera de entrada`)
  }
}

export function abrirBarreraSalidaBruto () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_SALIDA_BRUTO' })
    ControlBarreras.abrirBarreraSalidaBruto()
    toast.info(`Abriendo barrera de salida`)
  }
}

export function cerrarBarreraSalidaBruto () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_SALIDA_BRUTO' })
    ControlBarreras.cerrarBarreraSalidaBruto()
    toast.info(`Cerrando barrera de salida`)
  }
}

export function forzarBarreraBruto () {
  return (dispatch) => {
    Promise.all([
      ControlBarreras.forzarBarreraBruto(),
      dispatch(updateForzarBarrerasBruto('si'))
    ])
      .then(() => {
        dispatch({ type: 'FORZAR_BARRERAS_BRUTO' })
        toast.info('Barreras forzadas')
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function anularForzarBarreraBruto () {
  return (dispatch) => {
    Promise.all([
      ControlBarreras.anularForzarBarreraBruto(),
      dispatch(updateForzarBarrerasBruto('no'))
    ])
      .then(() => {
        dispatch({ type: 'ANULAR_FORZAR_BARRERAS_BRUTO' })
        toast.info('Forzado de barreras anulado.')
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function updateForzarBarrerasBruto (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_FORZAR_BARRERAS_BRUTO', newValue })
    dispatch(updateParametroText('FORBBRUT', newValue))
  }
}

export function actualizarEnclavamientoBarrerasBruto (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_ENCLAVAMIENTO_BARRERAS_BRUTO', newValue })
    dispatch(updateParametroInteger('ENBARRBR', newValue))
  }
}

export function actualizarEnclavamientoBarrerasDestare (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_ENCLAVAMIENTO_BARRERAS_DESTARE', newValue })
    dispatch(updateParametroInteger('ENBARRDE', newValue))
  }
}

export function calcularDiferenciaPesoTara (pesoOrigen, pesoActual) {
  return (dispatch) => {
    dispatch({
      type: 'CALCULAR_DIFERENCIA_TARA',
      pesoOrigen,
      pesoActual
    })
  }
}

export function resetDiferenciaPesoTara () {
  return dispatch => {
    dispatch({ type: 'RESET_DIFERENCIA_PESO_TARA' })
  }
}

export function updateConsultaCea (value) {
  return dispatch => {
    dispatch({ type: 'UPDATE_CONSULTA_CEA', value })
  }
}

export function resetConsultaCeaBruto () {
  return dispatch => {
    dispatch({ type: 'RESET_CEA_BRUTO' })
  }
}
export function resetConsultaCeaDestare () {
  return dispatch => {
    dispatch({ type: 'RESET_CEA_DESTARE' })
  }
}

export function updateCpeDestare (value) {
  return dispatch => {
    dispatch({ type: 'UPDATE_CPE_DESTARE', value })
  }
}

export function deleteCpeEnDestare (numero) {
  return dispatch => {
    // Se limpian estados de CPE y CEA
    dispatch(limpiarCeaDestare())
    dispatch({ type: 'RESET_CPE_DESTARE' })
    return LeerPesoDestare.deleteCpeEnDestare(numero)
  }
}

export function limpiarCeaDestare () {
  return dispatch => {
    dispatch({ type: 'RESET_CEA_DESTARE' })
  }
}

export function updateRepesoDestare (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_REPESO_DESTARE', newValue })
  }
}

export function descargaUpdateCpa (value) {
  return (dispatch) => {
    dispatch({
      type: 'DESCARGA_UPDATE_VALUE_CPA',
      value
    })
  }
}

export function resetPrinter () {
  return (dispatch) =>
    dispatch({ type: 'RESET_PRINTER_DESTARE' })
}

export function selectPrinter (printer, printerName) {
  return (dispatch) => {
    dispatch({
      type: 'SELECT_PRINTER_DESTARE',
      printer,
      printerName
    })
  }
}

export function resetPrinterComprobanteDescarga () {
  return (dispatch) =>
    dispatch({ type: 'RESET_PRINTER_DESCARGA' })
}

export function selectPrinterComprobanteDescarga (printerComprobanteDescarga, printerNameComprobanteDescarga) {
  return (dispatch) => {
    dispatch({
      type: 'SELECT_PRINTER_DESCARGA',
      printerComprobanteDescarga,
      printerNameComprobanteDescarga
    })
  }
}

export function getCpeEnBruto () {
  return (dispatch) => {
    return LeerPesoBruto.getCpePesadoBruto()
      .then((data) => dispatch({
        type: 'CPE_PESADO_BRUTO',
        data
      }))
  }
}

export function deleteCpeEnBruto (numero) {
  return dispatch => {
    dispatch(limpiarCeaDestare())
    dispatch({ type: 'RESET_CPE_BRUTO' })
    return LeerPesoBruto.deleteCpeEnBruto(numero)
  }
}

export function obtenerCallesVolcadora () {
  return getCallesVolcadora()
}

export function callesDeCaladoPorCerealHumedad () {
  return getCallesDeCaladoPorCerealHumedad()
}

export function calificacionCalleDeCalado () {
  return consultaCalificacionPorCalleCalado()
}

export function estadoOcupacionCallesDeCalados () {
  return consultaEstadoOcupacionCallesCalado()
}

export function getCamionesCalados () {
  return (dispatch) => {
    return TablaCamionesCaladosService.getDataCamionesCalados()
      .then((data) => {
        dispatch({
          type: 'RECEIVE_CAMIONES_CALADOS',
          data
        })
      }
      )
  }
}

export function camionesEntrePlayaCalado () {
  return getCamionesEntrePlayaCalado()
}

export function camionesListosParaBruto () {
  return getCamionesListosParaBruto()
}

export function obtenerEstadoPedidosCereal () {
  return getCortesPedidos()
}

export function obtenerCerealAsignadoAVolcadora () {
  return obtenerVolcadorasConCerealAsignado()
}

export function obtenerCamionesEntreBrutoYDestare () {
  return getCamionesEntreBrutoYDestare()
}

export function obtenerMotivosActividadBarrera () {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_MOTIVOS_ACTIVIDAD_BARRERA_BRUTO' })
    return ControlBarreras.getMotivosActividadBarreraBruto()
      .then((data) => {
        dispatch({ type: 'MOTIVOS_ACTIVIDAD_BARRERA_BRUTO', data })
      })
  }
}

export function guardarMotivoActividadBarrera () {
  return (dispatch, getState) => {
    const state = getState()
    const brutoValues = getFormValues(FORM_PESO_BRUTO)(state)

    if (brutoValues.motivoActBarrera) {
      const balanza = state.pesado.balanzaBruto
      const motivo = brutoValues.motivoActBarrera

      let ultimoPeso
      if (state.pesado.pesajeBruto === 'auto') {
        ultimoPeso = brutoValues.pesoCabezal
      } else {
        ultimoPeso = null
      }

      return ControlBarreras.submitMotivoActividadBarreraBruto(balanza, motivo, ultimoPeso)
        .then((result) => {
          console.log('result ', result)
          toast.success('Operación realizada correctamente.')
        })
        .catch(error => {
          console.log(error)
          toast.error('Error a intentar guardar el motivo de cambio de estado de barrera')
        })
    } else {
      toast.error('Es obligatorio seleccionar un motivo para cambiar el estado de la barrera de salida.')
    }
  }
}

export function actualizarDatos () {
  return (dispatch) => {
    dispatch(callesDeCaladoPorCerealHumedad())
    dispatch(calificacionCalleDeCalado())
    dispatch(estadoOcupacionCallesDeCalados())
    dispatch(getCamionesCalados())
    dispatch(camionesEntrePlayaCalado())
    dispatch(camionesListosParaBruto())
    dispatch(obtenerEstadoPedidosCereal())
    dispatch(obtenerCamionesEntreBrutoYDestare())
    dispatch(obtenerCerealAsignadoAVolcadora())
  }
}

export function updateHabilitacionVolcadoras (calle, habilitado) {
  return updateHabilitacionCalleDeVolcadora(calle, habilitado)
}

export function obtenerCallesDeBruto () {
  return async (dispatch) => {
    const calles = await calleDeBruto.getCallesDeBruto()
    dispatch({ type: 'CALLE_DE_BRUTO', calles })
  }
}

export function cargarPedidoDeBruto () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_PEDIDO_EGRESO_CALADO)(state)
    const roles = state.auth.roles
    formValues.caravana = !formValues.siloAparte

    dispatch({ type: 'SAVE_PEDIDO_DE_BRUTO' })
    return pedidoDeBruto.submitPedidoDeBrutoACalado(formValues)
      .then((result) => {
        if (!result.error) {
          toast.success('Se generó correctamente el pedido de camiones para bruto.')
          const rol = roles.filter(roles => roles === 'BALANCEROCAMIONES' || roles === 'DESARROLLADOR' || roles === 'SUPERVISOR')
          dispatch(actualizarDatosParaMuiTable(rol))
        } else {
          toast.error('Error al intentar generar el pedido de camiones.')
        }
        dispatch(reset(FORM_PEDIDO_EGRESO_CALADO))
      })
      .catch((error) => {
        toast.error('Error al intentar generar el pedido de camiones.')
        console.log('Error: ', error)
        dispatch(reset(FORM_PEDIDO_EGRESO_CALADO))
      })
  }
}

export function updateActualizacionHabilitada (newValue) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_ACTUALIZACION_HABILITADA', newValue })
  }
}

export function obtenerPedidosDeBruto () {
  return (dispatch) => {
    PedidoEgresoCalado.getPedidosDeBrutoACalado()
      .then((data) => {
        dispatch({ type: 'RECEIVE_PEDIDOS_DE_BRUTO', data })
      })
      .catch((error) => {
        console.log('Error. ', error)
      })
  }
}
